var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v("Copyright © "+_vm._s(new Date().getFullYear())+" 读者之星（天津）网络科技有限公司 版权所有")]),_c('p',[_vm._v("津ICP备2021009257号")])])}
var staticRenderFns = []

export { render, staticRenderFns }